<template>
	<v-container fluid class="height-100">
		<v-card elevation="0" class="height-100">
			<v-card-title>
				<v-icon class="mr-2" color="blue" size="28">mdi-account-group-outline</v-icon>
				员工管理<v-spacer />
				<v-btn @click="add" class="success float-right mt-1" elevation="0" :disabled="!['1', '2'].includes(user.mageIs)"><v-icon>mdi-plus</v-icon>新增</v-btn>
			</v-card-title>
			<v-card-title class="pt-0">
				<v-btn-toggle v-model="queryParam.mageIs" @change="searchQuery" color="primary" mandatory dense group class="ml-n2">
					<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index">{{ item.val }}</v-btn>
				</v-btn-toggle>
				<v-spacer />
				<v-text-field v-model="queryParam.condition" @click:append="searchQuery" @keyup.enter="searchQuery" style="max-width: 380px" outlined placeholder="请输入姓名/身份证号" append-icon="mdi-magnify" clearable dense hide-details></v-text-field>
			</v-card-title>
			<v-divider class="mx-4" />
			<v-card-text class="pt-0">
				<v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-footer>
					<template v-slot:[`item.first_col`]="{ item }">
						<span>{{ desserts.indexOf(item) + 1 }}</span>
					</template>
					<template v-slot:[`item.citizenId`]="{ item }">
						{{ item.citizenId | idcard }}
					</template>
					<template v-slot:[`item.telephone`]="{ item }">
						{{ item.telephone | mobile }}
					</template>

					<template v-slot:[`item.mageIs`]="{ item }">
						<v-chip :color="item.mageIs | dict('0:success/1:primary/2:error')" small>
							{{ item.mageIs | dict("0:业务员/1:管理员/2:超管员") }}
						</v-chip>
					</template>
					<template v-slot:[`item.areaCode`]="{ item }">
						<v-btn @click="area(item)" class="d-inline-block" color="success" icon :disabled="!['1', '2'].includes(user.mageIs)"><v-icon>mdi-map-marker-multiple</v-icon></v-btn>
					</template>
					<template v-slot:[`item.roles`]="{ item }">
						<v-btn @click="role(item)" class="d-inline-block" color="primary" icon :disabled="!['1', '2'].includes(user.mageIs)"><v-icon>mdi-account-multiple-check</v-icon></v-btn>
					</template>
					<template v-slot:[`item.mage`]="{ item }">
						<v-switch
							v-if="item.mageIs != 2"
							v-model="item.mageIs"
							@change="adm(item)"
							true-value="1"
							false-value="0"
							inset
							class="d-inline-block mt-0"
							hide-details
							dense
							:disabled="!['1', '2'].includes(user.mageIs) || item.citizenId == user.citizenId"></v-switch>
						<v-switch v-else input-value="true" inset class="d-inline-block mx-auto mt-0" hide-details dense disabled></v-switch>
					</template>
					<template v-slot:[`item.operateTime`]="{ item }">
						{{ item.operateTime | date("yyyy/MM/dd HH:mm:ss") }}
					</template>
					<template v-slot:[`item.actions`]="{ item }">
						<span v-if="item.citizenId == user.citizenId" @click="edit(item)" class="pointer blue--text mr-3">编辑</span>
						<span v-if="item.citizenId != user.citizenId && ['1', '2'].includes(user.mageIs)" @click="del(item)" class="pointer red--text mr-3">删除</span>
					</template>
					<template v-slot:no-data>
						<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
							<p class="grey--text mt-4">暂无数据</p>
						</v-card>
					</template>
				</v-data-table>
				<v-divider />
				<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
			</v-card-text>
		</v-card>

		<!-- 新增/编辑员工信息 -->
		<v-dialog v-model="dialogCreate" persistent max-width="500">
			<v-form ref="userCreate" v-model="userCreateValid">
				<v-card>
					<v-card-title>
						{{ !!userCreate.id ? "编辑" : "新增" }}<v-spacer></v-spacer>
						<v-btn class="mx-0" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
					</v-card-title>
					<v-divider />
					<v-card-text class="pb-1 pt-0">
						<!-- 用户预览 -->
						<v-list-item class="rounded my-4 pa-3" style="border: 1px dashed #99999952">
							<v-list-item-avatar class="rounded" color="blue-grey lighten-5" size="56">
								<v-img :src="userCreate.avatar || '/assets/img/user-avatar.png'" alt="头像" />
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="title font-weight-regular mb-1">{{ userCreate.citizenName || "员工姓名" }}</v-list-item-title>
								<v-list-item-subtitle style="line-height: unset"> 身份信息：{{ userCreate.citizenId || "身份证" }}（{{ userCreate.telephone || "手机号" }}） </v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
						<v-chip label class="mb-4" color="primary" text-color="white" style="height: 45px; width: 500px"> <v-icon left size="16">mdi-alert-circle</v-icon>{{ user.uniName }} </v-chip>
						<v-text-field placeholder="身份证号" :disabled="!!userCreate.id && userCreate.citizenId != '无'" dense outlined v-model="userCreate.citizenId" @blur="avatar()" :rules="rules.idCard"> </v-text-field>
						<v-text-field placeholder="用户姓名" :disabled="!!userCreate.id && userCreate.citizenName != '无'" dense outlined v-model="userCreate.citizenName" :rules="[(v) => !!v || '请输入姓名!']"></v-text-field>
						<v-text-field placeholder="手机号码" dense outlined v-model="userCreate.telephone" :rules="rules.mobile"></v-text-field>
						<v-textarea placeholder="用户说明" dense outlined v-model="userCreate.title" :rules="[(v) => !!v || '请输入用户说明!']" auto-grow></v-textarea>
						<p>
							注意：<br />
							1. 员工由企业管理员添加，离岗后可由管理员冻结；<br />
							2. 员工身份采用实名信息认证，请如实填相关系信息；<br />
							3. 员工添加成功后，系统可以使用短信码验证登录系统；<br />
							4. 以上信息请进行严格保密！！！
						</p>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="mx-auto">
						<v-spacer />
						<v-btn @click="close" text> 取消 </v-btn>
						<v-btn @click="submit" text color="primary"> 确定 </v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- 地区授权 -->
		<user-area ref="Marea" @ok="loadPage" />

		<!-- 服务角色 -->
		<user-role ref="Mrole" @ok="loadPage" />
	</v-container>
</template>
<script>
import Request from "@/commons/request";
import Message from "@/components/message";
import Storage from "@/commons/storage";
import Validation from "@/commons/validation";
import Mixins from "@/compositions/mixins/minxs";
import pagination from "@/components/pagination";
import userArea from "./user-area";
import userRole from "./user-role";
export default {
	name: "users-page",
	mixins: [Mixins],
	components: { pagination, userArea, userRole },
	data() {
		return {
			user: {},
			rules: {
				mobile: [(val) => Validation.isMobile(val) || "请填写正确的手机号码格式"],
				idCard: [(val) => Validation.isIdCard(val) || "请填写正确的身份证号码"],
			},
			dialogCreate: false,
			userCreate: {},
			userCreateValid: true,
			desserts: [],
			url: {
				list: "view/users/page",
			},
			headers: [
				{ text: "序号", value: "first_col", sortable: false, width: 60 },
				{ text: "姓名", value: "citizenName", sortable: false },
				{ text: "身份证号", value: "citizenId", sortable: false },
				{ text: "手机号码", value: "telephone", sortable: false },
				{ text: "管理角色", value: "mageIs", sortable: false, width: 130, align: "center" },
				{ text: "是否管理", value: "mage", sortable: false, width: 100 },
				{ text: "服务地区", value: "areaCode", sortable: false, width: 100, align: "center" },
				{ text: "服务角色", value: "roles", sortable: false, width: 100, align: "center" },
				{ text: "创建时间", value: "operateTime", sortable: false, width: 180 },
				{ text: "操作", value: "actions", sortable: false, width: 80 },
			],
			btnGroup: [
				{ key: "A", val: "全部" },
				{ key: "2", val: "超管员" },
				{ key: "1", val: "管理员" },
				{ key: "0", val: "业务员" },
			],
			queryParam: { mageIs: "A" },
			props: { multiple: true },
			areaArr: [], //地区
		};
	},
	activated() {
		this.user = Storage.get("_wit_acis_users");
		this.queryParam.did = this.user.did;
		this.loadPage();
		this.getTree();
	},
	methods: {
		close() {
			this.userCreate = {};
			this.dialogCreate = false;
		},
		//新增用户
		add() {
			this.$refs.userCreate?.reset();
			this.dialogCreate = true;
			this.userCreate = {};
			this.userCreate.id = "";
		},
		avatar() {
			// this.valid();
			if (this.userCreate.citizenId && this.userCreate.citizenId.length == 18) {
				this.userCreate.avatar = "/assets/img/user-avatar" + (this.userCreate.citizenId.slice(16, 17) % 2) + ".png";
			}
		},
		//编辑用户
		edit(item) {
			this.dialogCreate = true;
			this.userCreate = Object.assign({}, item);
		},
		// 删除用户信息
		del(item) {
			let title = item.mageIs == 2 ? "删除超管员提示" : "删除员工提示";
			let text = item.mageIs == 2 ? "你正在删除超管员，删除后该账号将无法登录并无法恢复，并且您将成为超管员，请谨慎操作！" : "是否确认删除该员工，删除后该账号将无法登录并无法恢复，请谨慎操作！";
			Message.confirm({ title: title, text: text }, (result) => {
				result &&
					Request.getForm("/view/users/delete", { uid: item.id, did: this.user.did }).then((res) => {
						if (res.meta.success) {
							Message.toast("删除成功", { color: "success" });
							this.queryParam.did = this.user.did;
							this.loadPage();
						} else {
							Message.toast("删除失败", { color: "error" });
						}
					});
			});
		},
		//设置管理员
		adm(item) {
			let txt = item.mageIs == "1" ? "是否设置该员工为管理员！" : "是否确认取消该员工管理员权限！";
			Message.confirm({ title: "提示", text: txt }, (result) => {
				if (result) {
					Request.postForm("/view/users/mage", { uid: item.id, did: this.user.did }).then((res) => {
						if (res.meta.success) {
							Message.toast("设置成功", { color: "success" });
						} else {
							Message.toast("设置失败", { color: "error" });
							item.mageIs = item.mageIs == "1" ? "0" : "1";
						}
					});
				} else {
					item.mageIs = item.mageIs == "1" ? "0" : "1";
				}
			});
		},
		//地区权限
		area(item) {
			this.$refs.Marea.opend(this.areaArr, item.areaCode, item.udi);
		},
		//地区
		getTree() {
			Request.postForm(`/dict/areas/tree/6`).then((res) => {
				this.areaArr = this.fromArray(res.data);
			});
		},
		fromArray(arrays) {
			let translator = (data, areaCode) => {
				let tree = [];
				arrays.forEach((item) => {
					if (item.areaCode.includes(areaCode) && item.areaLeve == areaCode.length + 2) {
						let temp = translator(data, item.areaCode);
						item.children = temp.length > 0 ? temp : undefined;
						tree.push(item);
					}
				});
				return tree;
			};
			//返回最终的结果
			return translator(arrays, "");
		},
		// 服务角色
		role(item) {
			this.$refs.Mrole.view(item);
		},
		async submit() {
			if (this.$refs.userCreate.validate()) {
				Message.loading.show();
				// 1.校验信息请求接口
				let data = this.userCreate.id ? { uid: this.userCreate.id } : { citizenId: this.userCreate.citizenId };
				let res = await Request.postJson("/view/users/valid", { did: this.user.did, telephone: this.userCreate.telephone, ...data });
				// 2.逻辑判断是否符合
				// 提取公共条件检查
				const nameMismatch = res.data.citizenName != this.userCreate.citizenName;
				// 2.1新增用户是逻辑判断当前部门是否存在相同用户
				if (res.data.deptHas == 1 && !this.userCreate.id) {
					// 部门中已存在该用户（编辑用户时则跳过当前这一步校验）| 姓名与预留信息部匹配  |  人员已存在于单位中
					Message.loading.hide();
					nameMismatch ? Message.toast("当前用户身份信息与系统中预留信息不匹配，请确认用户信息是否正确！", { color: "error" }) : Message.toast("当前人员已存在于单位中，不可重复添加", { color: "error" });
					return;
				}
				// 2.2新增（编辑）用户是逻辑判断当前系统中是否存在相同用户
				if (res.data.userHas == 1) {
					// 其他单位中已有该用户并且在本单位没有
					if (nameMismatch) {
						// 姓名与预留信息部匹配
						Message.loading.hide();
						Message.toast("当前用户身份信息与系统中预留信息不匹配，请确认用户信息是否正确！", { color: "error" });
						return;
					} else if (res.data.telephone != this.userCreate.telephone) {
						Message.loading.hide();
						// 与预留手机号不匹配
						Message.toast("当前用户在系统中已有预留手机号，请填写预留手机号码！", { color: "error" });
						return;
					}
				}
				// 3.提交用户信息
				let saveData = {
					uid: this.userCreate.id,
					did: this.user.did,
					operator: this.user.citizenName,
					...this.userCreate,
				};
				let saveRes = await Request.postJson("/view/users/save", saveData);
				Message.loading.hide();
				if (saveRes.meta.success) {
					Message.toast(saveRes.meta.message, { color: "success" });
					this.dialogCreate = false;
					this.loadPage();
				} else {
					Message.toast(saveRes.meta.message, { color: "error" });
				}
			}
		},
		tip() {
			Message.toast("当前应用开发中，尽请期待...", { color: "error" });
		},
	},
};
</script>

<style lang="scss" scoped>
.staff .v-tabs-slider-wrapper {
	z-index: -1;
	border-radius: 8px !important;
}
.staff .v-tab.v-tab {
	color: white;
}
.staff .theme--light.v-tabs-items,
.staff .theme--dark.v-tabs-items {
	background: none !important;
}
.staff .top-check {
	position: absolute;
	top: 4px;
	left: 8px;
}
.border-dashed {
	border: 1px #2196f3 dashed !important;
}
.border-solid {
	border: 1px rgba(182, 182, 182, 0.6) solid;
}
::v-deep .v-banner--single-line .v-banner__text {
	margin-left: -20px;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
.label_img {
	position: absolute;
	right: -2px;
	top: -2px;
}
.disabled {
	pointer-events: none;
	color: #bababa !important;
}
</style>
